<template>
  <div>
    <div style="display: compact;">


      <transition-group name="fade" tag="div" mode="out-in">
        <div v-if="language === 'en'" v-for="(item, index) in blocksEN"  :key="`section__${index}`">
          <content-block
              :id="`section__${index}`"
              :title="item.title"
              :tools="item.tools"
              :date="item.date"
              :is-flex="item.isFlex"
              :content="item.content"
              :images="item.images" />
        </div>
      </transition-group>
      <transition-group name="fade" tag="div" mode="out-in">
        <div v-if="language === 'hu'" v-for="(item, index) in blocksHU"  :key="`section-hu__${index}`">
          <content-block
              :id="`section__${index}`"
              :title="item.title"
              :tools="item.tools"
              :date="item.date"
              :is-flex="item.isFlex"
              :content="item.content"
              :images="item.images" />
        </div>
      </transition-group>

    </div>


  </div>
</template>

<script>
import ContentBlock from "../components/ContentBlock";

export default {
  name: "Home",
  computed: {
    language: function() {
      return this.$store.getters.language;
    }
  },
  components: {
    ContentBlock
  },
  methods:{
    changeCategory(id){
      this.bioCategory = id;
    }
  },
  data: function() {
    return {
      bioCategory: 'contact',
      blocksEN: [
        {
          tools: 'Video installation, photo, video, wood, glass',
          date: '2025',
          title: 'LITTLE GIRLS REUNION',
          content: `The starting point of the project Little Girls Reunion is a photograph taken in the late 1990s, in which the artist and her four friends imitate the poses of their favorite band, the Spice Girls, in front of a local McDonald's. This year, Zsuzsi Simon managed to reunite the former group members at the original location of the photograph, with whom she had lost contact many years earlier. In one of the videos presented in the installation, they talk about their childhood, the mass culture of the 1990s, and the impact of the political transition on their families. McDonald's, also evoked by the wooden frame of the installation, appears not only as the location of the original photo but as a symbol of the era: in the years following the collapse of the Soviet Union, it was framed in Eastern Europe as one of the first milestones marking the arrival of the West. In Hungary, the first restaurant opened in 1988 and was stormed by ten thousand customers on its first day.
`,
          images: [
            { src: require("../assets/img/littlegirls/littl_girls.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls2.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls3.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls4.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls5.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls6.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls7.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/little_girls_8.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/little_girls_9_01.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/little_girls_10.jpg"), claimed: false }
          ]
        },
      ],
      blocksHU: [
        {
          tools: 'Videóinstalláció, fotó, videó, fa, üveg',
          date: '2025',
          title: "LITTLE GIRLS REUNION",
          content: `A Little Girls Reunion című projekt kiindulópontja egy kilencvenes évek végén készült fotó, amin a művész négy barátnőjével kedvenc zenekaruk, a nem sokkal korábban berobbant Spice Girls csoportképének pózait imitálják egy helyi McDonald’s előtt. Simon Zsuzsinak idén sikerült újraegyesítenie az egykori csapat tagjait a fotó helyszínén, akikkel sok évvel korábban elvesztette a kapcsolatot. Az installációban látható egyik felvételen a találkozó keretében beszélgetnek a gyerekkorukról, a kilencvenes évek tömegkultúrájáról és a rendszerváltás hatásáról a családjukra.  A McDonald’s, amit az installáció fakerete is megidéz, a fotó helyszínén túl mint a korszak egyik szimbóluma jelenik meg: a Szovjetunió összeomlásának éveiben Kelet-Európában a nyugat megérkezésének egyik első mérföldköveként keretezték, Magyarországon 1988-ban nyílt az első éttermük, amit az első napon tízezer vevő rohamozott meg.`,
          images: [
            { src: require("../assets/img/littlegirls/littl_girls.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls2.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls3.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls4.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls5.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls6.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/littl_girls7.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/little_girls_8.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/little_girls_9_01.jpg"), claimed: false },
            { src: require("../assets/img/littlegirls/little_girls_10.jpg"), claimed: false }
          ]
        },
      ]
    };
  }
};
</script>

<style scoped>
.selector p{
  margin-right: 20px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>
